import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * CardHeaderComponent
 *
 * This component provides a flexible and styled card header section
 * with optional title, header visibility, and content projection via slot.
 *
 * Inputs:
 * - `headerClass`: Optional CSS class for the header container.
 * - `title`: Required string title to display in the header.
 * - `titleClass`: Optional CSS class for the title element.
 * - `titleParams`: Optional translation parameters for the title.
 * - `menuBodyClass`: Optional CSS class for the menu section (slot content).
 * - `showHeader`: Boolean flag to conditionally show/hide the header.
 *
 * Behavior:
 * - Dynamically builds CSS class names for header, title, and menu areas.
 * - Uses `<ng-content select="[slot=menu-body]">` to project external content
 *   into the menu body section.
 *
 * ⚠️ Note:
 * Styles targeting elements projected through the `slot="menu-body"` (i.e., content
 * passed via <ng-content>) must be defined in the parent component or in a global
 * stylesheet. Scoped styles defined in `card-header.component.scss` do **not**
 * apply to projected content due to Angular's ViewEncapsulation.
 */
@Component({
    selector: 'app-card-header',
    templateUrl: './card-header.component.html',
    styleUrls: ['./card-header.component.scss'],
    imports: [NgClass, TranslatePipe]
})
export class CardHeaderComponent implements OnInit {

  @Input() headerClass?: string;
  @Input() title: string;
  @Input() titleClass?: string;
  @Input() titleParams?: Record<string, any>;
  @Input() menuBodyClass?: string;
  @Input() showHeader?: boolean = true;
  @Input() showMenu?: boolean = true;

  constructor( ) {}

  ngOnInit(): void { }

  getHeaderClass(): string {
    const defaultClass = 'header';
    return this.headerClass ? `${defaultClass} ${this.headerClass}` : defaultClass;
  }

  getTitleClass(): string {
    const defaultClass = 'title';
    return this.titleClass ? `${defaultClass} ${this.titleClass}` : defaultClass;
  }

  getMenuClass(): string {
    const defaultClass = 'menu';
    return this.menuBodyClass ? `${defaultClass} ${this.menuBodyClass}` : defaultClass;
  }

}
